import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { MydocmaSettings, MYDOCMASETTINGS } from "@mydocma/core";
import { Project, ProjectStructureTree, ProjectStructureNode } from "@mydocma/project";
import { defer, map, Observable, tap } from "rxjs";
import { BasedataService } from "../../shared/basedata.service";
import { Structure, StructureNode } from "./structure.model";
import { BpConfigService } from "../../config/bp-config.service";

@Injectable({
  providedIn: 'root'
})
export class StructureApiService extends BasedataService {

  endpoint: string;

  constructor(private http: HttpClient, configService: BpConfigService, @Inject(MYDOCMASETTINGS) private mydocmaConfig: MydocmaSettings) {
    super(configService);
  }

  get(project: Project): Observable<ProjectStructureTree> {

    return this.http.get<ProjectStructureTree[]>(`${this.mydocmaConfig.apiUrl}/customers/${project.customerId}/projects/${project.id}/structures`)
    .pipe(
      map(ss => {
        const arr = ss ?? [];
        const uidById = new Map<string, string>();
        arr.forEach((s: any) => {
          const uid = s?.mydocmaUid ?? s?.myDocmaUid;
          if (s?.id && uid) uidById.set(s.id, uid);
        });
        const tree = ProjectStructureTree.loadTree(ss);
        this.assignMyDocmaUid(tree, uidById);
        return tree;
      }),
      tap(tree => tree.projectId = project.id)
    );

  }

  private assignMyDocmaUid(node: ProjectStructureNode, uidById: Map<string, string>): void {
    if (!node) return;
    const uid = uidById.get(node.id);
    if (uid) (node as StructureNode).myDocmaUid = uid;
    node.children?.forEach(child => this.assignMyDocmaUid(child, uidById));
  }

  getMockApiData(project: Project): Observable<Structure[]> {
    return defer(async () => {

      let structures: Structure[];
      if ( project.id === '183a0114-a350-4b61-90cb-eda0b2e19934' ) {
        structures = [
          { id: project.id, name: 'structure_name', desc: 'structure_desc', level: 0, },
              { id  : '2', name: 'B2', desc: 'Building 1', level: 1, parentId: '183a0114-a350-4b61-90cb-eda0b2e19934', },
              { id  : '22', name: 'B3', desc: 'Building 1', level: 1, parentId: '183a0114-a350-4b61-90cb-eda0b2e19934', },
                  { id  : '3', name: 'SubB1', desc: 'Sub Building 1', level: 2, parentId: '22', },
                      { id  : '4', name: 'SubB2', desc: 'Sub Building 1', level: 3, parentId: '3', },
                      { id  : '41', name: 'SubB3', desc: 'Sub Building 1', level: 3, parentId: '3', },
                  { id  : '5', name: 'SubB4', desc: 'Sub Building 1', level: 2, parentId: '22', },
              { id: '6', name: 'B5', desc: 'Building 2', level: 1, parentId: '183a0114-a350-4b61-90cb-eda0b2e19934', },

        ];
      } else if( project.id === '1668af5f-fe0b-420e-ba7a-3200e333874b' ) {
        structures = [
          { id: project.id, name: 'structure_name', desc: 'structure_desc', level: 0, },
          { id  : '2', name: 'B2', desc: 'Building 1', level: 1, parentId: '1668af5f-fe0b-420e-ba7a-3200e333874b', },
          { id  : '22', name: 'B3', desc: 'Building 1', level: 1, parentId: '1668af5f-fe0b-420e-ba7a-3200e333874b', },
          { id  : '3', name: 'SubB1', desc: 'Sub Building 1', level: 2, parentId: '22', },
        ];
      }

      return structures;
    })
  }
}
